export default function CtaSection() {
  return (
    <section className="relative bg-[#0f2044] py-24 px-4 md:px-8 overflow-hidden">
      {/* Background image overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6997b1181fb504d8b212503de7cb878b.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f2044] via-[#0f2044]/80 to-[#0f2044]" />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#2563eb]/12 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* ZB Consulting badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-8">
          <div className="w-6 h-6 bg-[#2563eb] rounded-md flex items-center justify-center">
            <span className="text-white font-black text-[10px]">ZB</span>
          </div>
          <span className="text-white/80 text-sm font-medium">ZB Advisor 2026</span>
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
          Abra e gerencie sua empresa nos EUA com{" "}
          <span className="text-[#60a5fa]">confiança</span>,{" "}
          de qualquer lugar.
          <br />
          <span className="text-white/70">Sem fronteiras. Sem limites.</span>
        </h2>

        <p className="text-white/60 text-lg mb-10 max-w-xl mx-auto leading-relaxed">
          Abra sua empresa nos EUA com quem entende os dois lados — Brasil e Estados Unidos. Atendimento humano, personalizado e em português.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#abrir-empresa"
            className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-semibold px-8 py-4 rounded-full transition-colors cursor-pointer text-center whitespace-nowrap text-base"
          >
            Abrir minha empresa agora
          </a>
          <a
            href="#contato"
            className="bg-white/10 hover:bg-white/20 text-white font-semibold px-8 py-4 rounded-full transition-colors cursor-pointer text-center whitespace-nowrap text-base border border-white/20"
          >
            Falar com um especialista
          </a>
        </div>

        {/* Trust row */}
        <div className="flex flex-wrap justify-center gap-6 mt-12">
          {[
            { icon: "ri-shield-check-line", text: "100% seguro e legal" },
            { icon: "ri-timer-line", text: "Abertura em 5 dias" },
            { icon: "ri-headphone-line", text: "Suporte em português" },
            { icon: "ri-star-line", text: "4.9/5 no Trustpilot" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-[#60a5fa] text-base`} />
              </div>
              <span className="text-white/50 text-sm">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
